$( document ).ready(function() {
  
  $(document).find('.mobile-header__icon svg').on('click',function(){
    $(document).find('.searchbar').css('display','none');
  });
  
  $(document).find('.drawer__close button').on('click',function(){
    $(document).find('.searchbar').css('display','block');
  });
  
  
    setInterval(function() {
      var nxtli = $(document).find('.container-mobile').find('.usp_active').next('li');
      if(nxtli.length > 0){
        $(document).find('.container-mobile').find('li').removeClass('usp_active');
        nxtli.addClass('usp_active');
      }
      else{
        $(document).find('.container-mobile').find('li').removeClass('usp_active');
        $(document).find('.container-mobile').find('li:first').addClass('usp_active');
      }
    }, 3000);
    
 
  
  
});
document.write("<style> #navtopset { top: 50px !important; }</style>");